export default __webpack_public_path__ + "static/media/backlot-logo.f24b4c68.png";